import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import consts from './consts';

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  consts
};